import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Menu,
  Typography,
  MenuItem,
  InputBase,
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
  Grid,
} from '@material-ui/core';
import * as Yup from 'yup';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { ChromeReaderMode, FileCopy, Today } from '@material-ui/icons';
import { checkSubmitData } from '../TemplateEdit/list';
import { EditIcon, DeleteIcon, DateIcon, CheckIcon } from '../../../../components/Icon';
import Dialog from '../../../../components/Dialog';
import rou from '../../../../router';
import { i18n } from '../../../../language';
import { classNames, onKeyUpEnterOrSpace } from '../../../../utils';
import { KeyboardDatePicker } from '../../../../components/DatePicker';
import webDesign from '../../../../static/images/template.png';
import { dutyAssignAPI } from '../../../../apis';

function getMorningTime(date) {
  if (date === null) return 0;
  const ndate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  return ndate.getTime();
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginBottom: '0.625rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  Template: {
    width: '100%',
    padding: '8.86% 0.1rem 25.3% 0.938rem',
    backgroundColor: '#e6efff',
    borderRadius: '0.375rem',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.25rem',
      height: '100%',
      backgroundColor: theme.palette.primary.main,
      zIndex: '9',
    },
  },
  Template1: {
    width: '100%',
    marginBottom: '0.625rem',
    padding: '8.86% 0.1rem 25.3% 0.938rem',
    backgroundColor: '#e6efff',
    borderRadius: '0.375rem',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.25rem',
      height: '100%',
      backgroundColor: theme.palette.primary.main,
      zIndex: '9',
    },
  },
  Template2: {
    width: '100%',
    marginBottom: '0.625rem',
    padding: '8.86% 0.1rem 25.3% 0.938rem',
    backgroundColor: '#e9faf6',
    borderRadius: '0.375rem',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.25rem',
      height: '100%',
      backgroundColor: theme.palette.status.green,
      zIndex: '9',
    },
  },
  Template3: {
    width: '100%',
    marginBottom: '0.625rem',
    padding: '8.86% 0.1rem 25.3% 0.938rem',
    backgroundColor: '#fff0f0',
    borderRadius: '0.375rem',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.25rem',
      height: '100%',
      backgroundColor: '#ff7270',
      zIndex: '9',
    },
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    lineHeight: '1rem',
    fontWeight: 'bold',
    marginBottom: '0.25rem',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
  },
  context: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    letterSpacing: '0',
    fontWeight: '500',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
  },
  menu: {
    '& .MuiList-padding': {
      borderRadius: '0.16875rem',
    },
    '& .MuiPopover-paper': {
      overflow: 'visible',
      marginTop: '4rem',
      borderRadius: '0.16875rem',
      boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  menuItem: {
    width: '13.313rem',
    height: '3.75rem',
    padding: '1.125rem 0',
    backgroundColor: theme.palette.font.white,
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  menuIcon: {
    fontSize: '1.25rem',
    margin: '0 1.063rem',
    color: theme.palette.font.main,
  },
  menuText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  dialogContext: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  editTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
  editInput: {
    paddingLeft: '1.25rem',
    width: '40.313rem',
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
  },
  error: {
    borderColor: '#f44336 !important',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginTop: '0.5rem',
  },
  cardbody: {
    width: '18.688rem',
    height: '5.438rem',
    borderRadius: '0.9375rem',
    boxShadow: '0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.04)',
    border: '0.0625rem solid #e4e7eb',
    padding: '0 0 0 1.875rem',
    display: 'flex',
    alignItems: 'center',
    margin: '1.25rem 1.25rem 0 0',
    position: 'relative',
  },
  cardimg: {
    width: '2.313rem',
    height: '3.25rem',
    marginRight: '1.25rem',
  },
  cardTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
  },
  dialogCardbody: {
    display: 'flex',
    flexWrap: 'wrap',
    '& >div:nth-child(2n+0)': {
      marginRight: '0',
    },
  },
  radioBody: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '1.25rem',
  },
  label: {
    margin: '0',
    width: '10.5rem',
    '& .MuiTypography-body1': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: '500',
    },
  },
  radio: {
    color: '#e4e7eb',
  },
  checkicon: {
    fontSize: '0.75rem',
    color: theme.palette.font.white,
    margin: '0 auto',
  },
  iconbody: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1rem',
    marginRight: '0.938rem',
  },
  cardchoose: {
    // width: '18.688rem',
    height: '5.438rem',
    borderRadius: '0.9375rem',
    boxShadow: '0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.04)',
    border: '0.125rem solid #538fff',
    padding: '0 0 0 1.875rem',
    display: 'flex',
    // flex: 1,
    alignItems: 'center',
    margin: '0.25rem 1.25rem 0 0',
    position: 'relative',
    backgroundColor: 'rgba(83, 143, 255, 0.1)',
  },
  dialogBody: {
    overflowY: 'auto',
    width: '100%',
  },
  dialogBodyDatePicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '11.938rem',
      height: '3rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      padding: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0.75rem',
    },
  },
  dialogBodyDatePickerDisabled: {
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: '#aaa',
      fontWeight: 'normal',
      width: '11.938rem',
      height: '3rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      padding: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0.75rem',
    },
  },

  Picon: {
    color: '#c0c6cb',
  },
  datePickerError: {
    '& .MuiInputBase-root': {
      borderColor: '#f44336 !important',
    },
  },
}));

function TemplateCard({ title, roster }) {
  const classes = useStyles();

  return (
    <div className={classes.cardchoose}>
      <img className={classes.cardimg} src={webDesign} alt="" />
      <div className={classes.cardcontext}>
        <div className={classes.cardTitle}>{roster}</div>
        <div className={classes.context}>{title}</div>
      </div>
      <div className={classes.iconbody}>
        <CheckIcon className={classes.checkicon} />
      </div>
    </div>
  );
}
export default function Card({
  title,
  context,
  template,
  id,
  handleEdit,
  handleDelete,
  date,
  handleBatchDelete,
  handleCopy,
  templateIndex = 0,
}) {
  const history = useHistory();
  const classes = useStyles();
  const [error, setError] = useState({});

  const dates = date.split('/');
  const rosterDate = new Date(dates[2], dates[1] - 1, dates[0]);
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);

  const nameSchema = {
    title: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_CHECK_TITLE') })
    ),
  };

  const focusCheck = (name, value) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: nameSchema[name] }), { [name]: value });
        setError({ ...error, [name]: null });
      } catch (e) {
        setError({ ...error, ...e });
      }
    };
  };

  function color() {
    switch (template) {
      case 'template1':
        return '#32579e';
      case 'template2':
        return '#1f846d';
      case 'template3':
        return '#d8403e';
      default:
        break;
    }
  }

  function rootColor() {
    switch (template) {
      case 'template1':
        return classes.Template1;
      case 'template2':
        return classes.Template2;
      case 'template3':
        return classes.Template3;
      default:
        break;
    }
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCardElementId, setSelectedCardElementId] = useState('');
  const [anchorPosition, setAnchorPosition] = useState({ left: 0, top: 0 });
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setSelectedCardElementId(event.currentTarget.id);
    setAnchorPosition({
      top: event.clientY - event.nativeEvent?.layerY + event.currentTarget?.clientHeight * 0.65,
      left: event.clientX - event.nativeEvent?.layerX + event.currentTarget?.clientWidth * 0.5,
    });
    setAnchorEl(event);
  };

  const handleClose = () => {
    setSelectedCardElementId('');
    setAnchorEl(null);
  };
  const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date.getTime());
  };

  const loginInfo = useSelector((state) => state.loginInfo);

  const [dialogopen, setDialogopen] = useState(false);
  const [editopen, setEditopen] = useState(false);
  const [deletebatchopen, setDeletebatchopen] = useState(false);
  const [deleteDialogConfirmOpen, setDeleteDialogConfirmOpen] = useState(false);
  const [deleteNumberConfirmOpen, setDeleteNumberConfirmOpen] = useState(false);
  const [includeUsing, setIncludeUsing] = useState(false);
  const [deleteRosterDetail, setDeleteRosterDetail] = useState('');
  const [toDate, setToDate] = useState(null);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [editvalue, setEditvalue] = useState(title);
  const [copyopen, setCopyopen] = useState(false);
  const [copyStaff, setCopyStaff] = useState(false);
  const [autoFillIn, setAutoFillIn] = useState(false);
  const [overwriteRoster, setOverwriteRoster] = useState(false);
  const [unselectRepeat, setUnselectRepeat] = useState(true);
  const [dailyRepeatDate, setDailyRepeatDate] = useState(null);
  const [dailyRepeatSelected, setDailyRepeatSelected] = useState(false);
  const [weeklyRepeatDate, setWeeklyRepeatDate] = useState(null);
  const [weeklyRepeatSelected, setWeeklyRepeatSelected] = useState(false);
  const [copyNumberConfirmOpen, setCopyNumberConfirmOpen] = useState(false);
  const [copyRosterDetail, setCopyRosterDetail] = useState('');
  const [skipAllcopyData, setSkipAllcopyData] = useState(false);

  useEffect(() => {
    setEditvalue(title);
  }, [title]);

  const templateInfoView = () => {
    return (
      <>
        <div className={classes.title} style={{ marginBottom: '0.725rem' }}>
          {i18n.t('DUTYASSIGN_ROSTER_SELECT_ROSTER')}
        </div>
        <div className={classes.dialogCardbody}>
          <TemplateCard title={template} roster={title} choose={true} formData={{}} />
        </div>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <div className={classes.title} style={{ marginTop: '1.875rem', marginBottom: '0.725rem' }}>
              {i18n.t('DUTYASSIGN_ROSTER_FROM_DATE')}
            </div>
            <KeyboardDatePicker
              className={classes.dialogBodyDatePickerDisabled}
              keyboardIcon={<DateIcon className={classes.Picon} />}
              id="DutyAssign-KeyboardDatePicker-afc"
              variant="dialog"
              format="DD-MM-yyyy"
              inputVariant="outlined"
              InputAdornmentProps={{ position: 'end' }}
              disabled={true}
              value={rosterDate}
              onChange={(value) => {}}
            />
          </Grid>
          <Grid item xs={6}>
            <div className={classes.title} style={{ marginTop: '1.875rem', marginBottom: '0.725rem' }}>
              {i18n.t('DUTYASSIGN_ROSTER_END_DATE')}
            </div>
            <KeyboardDatePicker
              className={
                error?.dailyEndTime
                  ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                  : classes.dialogBodyDatePicker
              }
              keyboardIcon={<DateIcon className={classes.Picon} style={{ color: '#538fff' }} />}
              id="DutyAssign-KeyboardDatePicker-afc"
              variant="dialog"
              format="DD-MM-yyyy"
              inputVariant="outlined"
              InputAdornmentProps={{ position: 'end' }}
              placeholder={i18n.t('DUTYASSIGN_ROSTER_END_DATE')}
              value={toDate}
              minDate={rosterDate}
              maxDate={moment(rosterDate).add('month', 6)}
              onChange={(value) => {
                const date = new Date(value);
                if (!isValidDate(date)) {
                  setConfirmDisabled(true);
                } else {
                  if (date.getTime() >= rosterDate.getTime()) {
                    setConfirmDisabled(false);
                  } else {
                    setConfirmDisabled(true);
                  }
                }
                setToDate(new Date(value));
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <div className={classes.root}>
      <div
        className={classNames(classes.Template, rootColor())}
        style={{ backgroundColor: `DutyAssign-div-afe-${id}` === selectedCardElementId ? '#ADCAFF' : '#e6efff' }}
        onClick={handleClick}
        id={`DutyAssign-div-afe-${id}`}
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, handleClick)}
      >
        <Typography className={classes.title} style={{ color: color() }} title={title}>
          {title}
        </Typography>
        <Typography className={classes.context} style={{ color: color() }} title={context}>
          {context}
        </Typography>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        id="DutyAssign-Menu-aff"
        onClose={handleClose}
        keepMounted
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
      >
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
            dutyDateInfo.id = id;
            dutyDateInfo.date = rosterDate;
            dutyDateInfo.index = templateIndex;
            sessionStorage.setItem('dutyInfo', JSON.stringify(dutyDateInfo));
            history.push(rou.dutyassignRou.path);
          }}
          id="DutyAssign-MenuItem-view"
        >
          <Today className={classes.menuIcon} />
          <Typography className={classes.menuText}>{i18n.t('DUTYASSIGN_ROSTER_VIEW_ROSTER')}</Typography>
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
            dutyDateInfo.id = id;
            dutyDateInfo.date = rosterDate;
            dutyDateInfo.index = templateIndex;
            sessionStorage.setItem('dutyInfo', JSON.stringify(dutyDateInfo));
            history.push(rou.attendanceRou.path);
          }}
          id="DutyAssign-MenuItem-view-att"
          style={{ borderTop: '1px solid #e4e7eb' }}
        >
          <ChromeReaderMode className={classes.menuIcon} />
          <Typography className={classes.menuText}>{i18n.t('DUTYASSIGN_ROSTER_PLANNER_VIEW_ATTENDANCE')}</Typography>
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            setEditopen(true);
          }}
          id="DutyAssign-MenuItem-afg"
          style={{ borderTop: '1px solid #e4e7eb' }}
        >
          <EditIcon className={classes.menuIcon} />
          <Typography className={classes.menuText}>{i18n.t('STAFF_TEMPORARY_EDIT')}</Typography>
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            setDialogopen(true);
          }}
          id="DutyAssign-MenuItem-afh"
          style={{ borderTop: '1px solid #e4e7eb' }}
        >
          <DeleteIcon className={classes.menuIcon} />
          <Typography className={classes.menuText}>{i18n.t('STAFF_TEMPORARY_DELETE')}</Typography>
        </MenuItem>
        {today <= rosterDate && (
          <MenuItem
            className={classes.menuItem}
            onClick={() => {
              setToDate(null);
              setConfirmDisabled(true);
              setDeletebatchopen(true);
            }}
            id="DutyAssign-MenuItem-afh2"
            style={{ borderTop: '1px solid #e4e7eb' }}
          >
            <DeleteIcon className={classes.menuIcon} />
            <Typography className={classes.menuText}>{i18n.t('DUTYASSIGN_ROSTER_BATCH_DELETE')}</Typography>
          </MenuItem>
        )}
      </Menu>
      <Dialog
        open={editopen}
        id="DutyAssign-Dialog-afi"
        title={i18n.t('DUTYASSIGN_PLANNER_EDIT_TITLE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        cancelID="DutyAssign-Dialog-afi-cancel"
        confirmID="DutyAssign-Dialog-afi-confirm"
        closeID="DutyAssign-Dialog-afi-close"
        handleCancel={() => {
          setEditvalue(title);
          setError({});
          setEditopen(false);
        }}
        handleClose={() => {
          setEditvalue(title);
          setError({});
          setEditopen(false);
        }}
        handleConfirm={() => {
          if (editvalue?.length === 0) {
            return;
          }
          handleEdit(id, editvalue);
          setEditvalue(title);
          setError({});
          setEditopen(false);
          setSelectedCardElementId('');
          setAnchorEl(null);
        }}
        confirmStyle={{ opacity: editvalue?.length === 0 ? 0.2 : 1 }}
      >
        <div className={classes.editTitle}>{i18n.t('DUTYASSIGN_PLANNER_EDIT_SUBTITLE')}</div>
        <InputBase
          className={error.title ? classNames(classes.editInput, classes.error) : classes.editInput}
          value={editvalue}
          onChange={(event) => {
            if (event.target.value.length > 60) {
              event.target.value = event.target.value.slice(0, 60);
            }
            setEditvalue(event.target.value);
          }}
          id="DutyAssign-InputBase-afj"
          onBlur={() => {
            (async () => {
              await focusCheck('title', editvalue)();
            })();
          }}
        />
        {error.title && <div className={classes.errorMsg}>{error.title}</div>}
      </Dialog>
      <Dialog
        open={dialogopen}
        id="DutyAssign-Dialog-afk"
        title={i18n.t('DUTYASSIGN_PLANNER_DELETE_TITLE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        cancelID="DutyAssign-Dialog-afk-cancel"
        confirmID="DutyAssign-Dialog-afk-confirm"
        closeID="DutyAssign-Dialog-afk-close"
        handleCancel={() => {
          setDialogopen(false);
        }}
        handleClose={() => {
          setDialogopen(false);
        }}
        handleConfirm={() => {
          handleDelete(id);
          setDialogopen(false);
          setAnchorEl(null);
        }}
      >
        <div className={classes.dialogContext}>{i18n.t('DUTYASSIGN_PLANNER_DELETE_BODY')}</div>
      </Dialog>
      {deleteDialogConfirmOpen ? (
        <Dialog
          open={deleteDialogConfirmOpen}
          id="DutyAssign-DiaLog-aik-delete"
          cancel={i18n.t('EQUIPMENT_CONFIRM_OK')}
          readOnly={true}
          title={i18n.t('DUTYASSIGN_ROSTER_DELETE_INFO')}
          handleClose={() => {
            setDeleteDialogConfirmOpen(false);
          }}
          handleCancel={() => {
            setDeleteDialogConfirmOpen(false);
          }}
        >
          <div className={classes.publishBody}>{i18n.t('DUTYASSIGN_ROSTER_DELETE_ROSTER_NOT_FOUND')} </div>
        </Dialog>
      ) : null}
      {deleteNumberConfirmOpen ? (
        <Dialog
          open={deleteNumberConfirmOpen}
          id="DutyAssign-DiaLog-aik-number"
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          title={i18n.t('DUTYASSIGN_ROSTER_DELETE_INFO')}
          handleCancel={() => {
            setDeleteNumberConfirmOpen(false);
          }}
          handleClose={() => {
            setDeleteNumberConfirmOpen(false);
          }}
          handleConfirm={() => {
            const payload = {
              action: 'POST',
              rosterName: title,
              from: getMorningTime(rosterDate),
              to: getMorningTime(toDate),
              includeUsing: includeUsing ? 1 : 0,
              templateName: template,
            };
            dutyAssignAPI.postDeleteBatchTemplateRoster(payload).then((res) => {
              if (res?.statusCode === '0') {
                setDeleteNumberConfirmOpen(false);
                setDeletebatchopen(false);
                (async () => {
                  handleBatchDelete();
                })();
              }
            });
          }}
        >
          <div className={classes.publishBody}>{deleteRosterDetail}</div>
        </Dialog>
      ) : null}
      <Dialog
        open={deletebatchopen}
        title={i18n.t('DUTYASSIGN_ROSTER_BATCH_DELETE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        cancelID="DutyAssign-div-aex-cancel"
        confirmID="DutyAssign-div-aex-confirm"
        closeID="DutyAssign-div-aex-close"
        confirmStyle={{}}
        id="DutyAssign-Dialog-aey"
        disabled={confirmDisabled}
        handleCancel={() => {
          setDeletebatchopen(false);
        }}
        handleClose={() => {
          setDeletebatchopen(false);
        }}
        handleConfirm={() => {
          const payload = {
            action: 'PRE',
            rosterName: title,
            from: getMorningTime(rosterDate),
            to: getMorningTime(toDate),
            includeUsing: includeUsing ? 1 : 0,
            templateName: template,
          };
          dutyAssignAPI.postDeleteBatchTemplateRoster(payload).then(async (res) => {
            if (res?.statusCode === '0') {
              if (res.result.deletedCount === 0) {
                setDeleteDialogConfirmOpen(true);
              } else if (res.result.deletedCount === res.result.totalCount) {
                setDeleteRosterDetail(`${res.result.deletedCount}${i18n.t('DUTYASSIGN_ROSTER_DELETE_CONTENT')}`);
                setDeleteNumberConfirmOpen(true);
              } else {
                setDeleteRosterDetail(
                  `${res.result.deletedCount}${i18n.t('DUTYASSIGN_ROSTER_DELETE_CONTENT1')}${
                    res.result.totalCount - res.result.deletedCount
                  }${i18n.t('DUTYASSIGN_ROSTER_DELETE_CONTENT2')}`
                );
                setDeleteNumberConfirmOpen(true);
              }
            }
          });
        }}
      >
        <div className={classes.dialogBody} style={{ overflowY: 'hidden' }}>
          {templateInfoView()}
          <Box display="flex" alignItems="center" mt="1rem">
            <Checkbox
              check={includeUsing}
              id="first"
              onChange={(event) => {
                setIncludeUsing(event.target.checked);
              }}
              style={{ color: '#538fff' }}
            />
            <div style={{ fontSize: '1rem' }}>{i18n.t('DUTYASSIGN_ROSTER_ALSO_DELETE_ALL')}</div>
          </Box>
        </div>
      </Dialog>

      {copyNumberConfirmOpen ? (
        <Dialog
          open={copyNumberConfirmOpen}
          id="DutyAssign-DiaLog-aik-number"
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          title={i18n.t('DUTYASSIGN_ROSTER_DELETE_INFO')}
          handleCancel={() => {
            setCopyNumberConfirmOpen(false);
            setSkipAllcopyData(false);
          }}
          handleClose={() => {
            setCopyNumberConfirmOpen(false);
            setSkipAllcopyData(false);
          }}
          readOnly={skipAllcopyData ? true : false}
          handleConfirm={() => {
            const payload = {
              action: 'POST',
              templateRosterId: id,
              incluceStaff: Number(copyStaff),
              invokeAFR: Number(autoFillIn),
              overwriteExisting: Number(overwriteRoster),
              to: getMorningTime(toDate),
              repeatDailyTo: getMorningTime(dailyRepeatDate),
              repeatWeeklyTo: getMorningTime(weeklyRepeatDate),
              userId: loginInfo?.userId,
            };
            dutyAssignAPI.duplicateDraft(payload).then((res) => {
              if (res?.statusCode === '0') {
                setCopyNumberConfirmOpen(false);
                setCopyopen(false);
                (async () => {
                  handleCopy();
                })();
              }
            });
          }}
        >
          <div className={classes.publishBody}>{copyRosterDetail}</div>
        </Dialog>
      ) : null}
      <Dialog
        open={copyopen}
        title="Copy template"
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        cancelID="DutyAssign-div-aex-cancel"
        confirmID="DutyAssign-div-aex-confirm"
        closeID="DutyAssign-div-aex-close"
        dialogfootStyle={{ marginTop: '1rem' }}
        confirmStyle={{}}
        id="DutyAssign-Dialog-aey"
        disabled={confirmDisabled}
        handleCancel={() => {
          setCopyopen(false);
        }}
        handleClose={() => {
          setCopyopen(false);
        }}
        handleConfirm={() => {
          const payload = {
            action: 'PRE',
            templateRosterId: id,
            incluceStaff: Number(copyStaff),
            invokeAFR: Number(autoFillIn),
            overwriteExisting: Number(overwriteRoster),
            to: getMorningTime(toDate),
            repeatDailyTo: getMorningTime(dailyRepeatDate),
            repeatWeeklyTo: getMorningTime(weeklyRepeatDate),
            userId: loginInfo?.userId,
          };
          dutyAssignAPI.duplicateDraft(payload).then((res) => {
            if (res?.statusCode === '0') {
              let copyInfo = `The source roster is ${res.result.sourceType} saved by ${res.result.sourceBy} at ${moment(
                res.result.sourceDate
              ).format('DD-MM-yyyy')}. It will duplcate to ${res.result.totalCount} roster(s) `;
              if (res.result.skipCount > 0) {
                copyInfo = `${copyInfo}${res.result.skipCount} roster(s) will be skip `;
              }
              if (res.result.overwriteCount > 0) {
                copyInfo = `${copyInfo}${res.result.overwriteCount} roster(s) will be overwriter`;
              }
              if (res.result.skipCount === res.result.totalCount) {
                setSkipAllcopyData(true);
              }
              setCopyRosterDetail(copyInfo);
              setCopyNumberConfirmOpen(true);
            }
          });
        }}
      >
        <div className={classes.dialogBody}>
          {templateInfoView()}
          <div className={classes.title} style={{ marginTop: '1.875rem', marginBottom: '1.438rem' }}>
            {i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_CUTOMIZE_TITLE')}
          </div>
          <RadioGroup className={classes.radioBody} row defaultValue="2">
            <Box display="flex">
              <FormControlLabel
                className={classes.label}
                value="1"
                control={
                  <Radio
                    className={classes.radio}
                    color="primary"
                    id="DutyAssign-RadioGroup-afb-0"
                    checked={dailyRepeatSelected}
                    disabled={!isValidDate(toDate)}
                    onChange={(e) => {
                      if (!isValidDate(dailyRepeatDate)) {
                        setConfirmDisabled(true);
                      }
                      setDailyRepeatSelected(e.target.checked);
                      setWeeklyRepeatSelected(false);
                      setWeeklyRepeatDate(null);
                      setUnselectRepeat(false);
                    }}
                  />
                }
                label={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_DAILY')}
                labelPlacement="end"
                style={{ marginBottom: '1.75rem' }}
              />
              <KeyboardDatePicker
                className={
                  error?.dailyEndTime
                    ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                    : classes.dialogBodyDatePicker
                }
                keyboardIcon={
                  <DateIcon
                    className={classes.Picon}
                    style={{ color: dailyRepeatSelected && isValidDate(toDate) ? '#538fff' : '#c0c6cb' }}
                  />
                }
                id="DutyAssign-KeyboardDatePicker-afc"
                variant="dialog"
                format="DD-MM-yyyy"
                inputVariant="outlined"
                InputAdornmentProps={{ position: 'end' }}
                placeholder="Select end date"
                disabled={!dailyRepeatSelected || !isValidDate(toDate)}
                value={dailyRepeatDate}
                minDate={moment(toDate).add('day', 1)}
                maxDate={moment(toDate ? toDate : rosterDate).add('month', 1)}
                onError={(e) => {
                  if (e) {
                    setConfirmDisabled(true);
                  }
                }}
                onChange={(value) => {
                  const date = new Date(value);
                  if (!isValidDate(date)) {
                    setConfirmDisabled(true);
                  } else {
                    if (date.getTime() >= toDate.getTime()) {
                      setConfirmDisabled(false);
                    } else {
                      setConfirmDisabled(true);
                    }
                  }
                  setDailyRepeatDate(new Date(value));
                }}
              />
            </Box>
            <Box display="flex">
              <FormControlLabel
                className={classes.label}
                value="2"
                control={
                  <Radio
                    className={classes.radio}
                    color="primary"
                    id="DutyAssign-RadioGroup-afb-1"
                    checked={weeklyRepeatSelected}
                    disabled={!isValidDate(toDate)}
                    onChange={(e) => {
                      if (!isValidDate(weeklyRepeatDate)) {
                        setConfirmDisabled(true);
                      }
                      setWeeklyRepeatSelected(e.target.checked);
                      setDailyRepeatSelected(false);
                      setDailyRepeatDate(null);
                      setUnselectRepeat(false);
                    }}
                  />
                }
                label={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_WEEKLY')}
                style={{ marginBottom: '1.75rem' }}
                labelPlacement="end"
              />
              <KeyboardDatePicker
                className={
                  error?.weeklyEndTime
                    ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                    : classes.dialogBodyDatePicker
                }
                keyboardIcon={
                  <DateIcon
                    className={classes.Picon}
                    style={{ color: weeklyRepeatSelected && isValidDate(toDate) ? '#538fff' : '#c0c6cb' }}
                  />
                }
                id="DutyAssign-KeyboardDatePicker-afd"
                variant="dialog"
                format="DD-MM-yyyy"
                inputVariant="outlined"
                InputAdornmentProps={{ position: 'end' }}
                placeholder="Select end date"
                disabled={!weeklyRepeatSelected || !isValidDate(toDate)}
                value={weeklyRepeatDate}
                minDate={moment(toDate).add('day', 1)}
                maxDate={moment(toDate).add('month', 1)}
                onError={(e) => {
                  if (e) {
                    setConfirmDisabled(true);
                  }
                }}
                onChange={(value) => {
                  const date = new Date(value);
                  if (!isValidDate(date)) {
                    setConfirmDisabled(true);
                  } else {
                    if (date.getTime() >= toDate.getTime()) {
                      setConfirmDisabled(false);
                    } else {
                      setConfirmDisabled(true);
                    }
                  }
                  setWeeklyRepeatDate(new Date(value));
                }}
              />
            </Box>
            <FormControlLabel
              className={classes.label}
              value="0"
              control={
                <Radio
                  className={classes.radio}
                  color="primary"
                  id="DutyAssign-RadioGroup-afb-2"
                  checked={unselectRepeat}
                  onChange={(e) => {
                    setUnselectRepeat(e.target.checked);
                    setWeeklyRepeatSelected(false);
                    setDailyRepeatSelected(false);
                    setDailyRepeatDate(null);
                    setWeeklyRepeatDate(null);
                    if (isValidDate(toDate) && toDate >= rosterDate) {
                      setConfirmDisabled(false);
                    }
                  }}
                />
              }
              label={i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_NONE')}
              labelPlacement="end"
            />
          </RadioGroup>
        </div>
        <div className={classes.title}>Copy Option</div>
        <FormGroup style={{ marginBottom: '2em' }}>
          <FormControlLabel
            control={
              <Checkbox
                check={copyStaff}
                id="first"
                onChange={(event) => {
                  setCopyStaff(event.target.checked);
                }}
                style={{ color: '#538fff' }}
              />
            }
            label="Copy Staff Assignment"
          />
          <FormControlLabel
            control={
              <Checkbox
                check={autoFillIn}
                id="first"
                onChange={(event) => {
                  setAutoFillIn(event.target.checked);
                }}
                style={{ color: '#538fff' }}
              />
            }
            label="Invoke Auto Fill-in Rule"
          />
          <FormControlLabel
            control={
              <Checkbox
                check={overwriteRoster}
                id="first"
                onChange={(event) => {
                  setOverwriteRoster(event.target.checked);
                }}
                style={{ color: '#538fff' }}
              />
            }
            label="Overwrite Existing Roster(if any)"
          />
        </FormGroup>
      </Dialog>
    </div>
  );
}
